import { useState, useContext } from "react";
import { PassCodeContext } from "../PassCodeContext/PassCodeContext";

function PasscodePage() {
  const [input, setInput] = useState("");
  const { setAuthorized } = useContext(PassCodeContext);

  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAuthorized(true);

    const res = await fetch(`/passcode`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ code: input })
    });

    const data = await res.json();
    
    console.log('data', data)

    if (data.valid) {
      setAuthorized(true);
    } else {
      alert("Incorrect passcode");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Enter Passcode</h2>

      <input
        type="password"
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />

      <button type="submit">Submit</button>
    </form>
  );
}

export default PasscodePage;